import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import EquipmentTypePicker, {
  IEquipmentTypePickerProps,
} from 'components/domain/equipment/EquipmentTypePicker/EquipmentTypePicker';

interface IEquipmentTypeFormFieldProps<EquipmentTypeIdType extends string>
  extends Omit<IEquipmentTypePickerProps<EquipmentTypeIdType>, 'value' | 'onSelect'> {
  className?: ClassName;
  form: any;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
}

function EquipmentTypeFormField<EquipmentTypeIdType extends string>(
  props: IEquipmentTypeFormFieldProps<EquipmentTypeIdType>
) {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'equipment-type-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <EquipmentTypePicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default EquipmentTypeFormField;
